import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
// slices
import calendarReducer from './slices/calendar';

// ----------------------------------------------------------------------

export const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

export const rootReducer = combineReducers({
  calendar: calendarReducer,
});
